import { useEffect, useState } from 'react';

import Button from '@components/button/Button';
import { Category } from 'types/categoryInput';

interface EditCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (category: Category) => void;
  editingItem: Category | null;
}

const EditCategoryModal = ({
  isOpen,
  onClose,
  onSave,
  editingItem: category
}: EditCategoryModalProps) => {
  const [categoryName, setCategoryName] = useState(category?.name || '');

  useEffect(() => {
    if (category) {
      setCategoryName(category.name || '');
    }
  }, [category]);

  const handleSave = () => {
    if (category && categoryName.trim()) {
      const updatedCategory: Category = {
        ...category,
        name: categoryName.trim()
      };
      onSave(updatedCategory);
      onClose();
    }
  };

  const handleCancel = () => {
    setCategoryName(category?.name || '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      data-edit-modal
    >
      <div className="w-[353px] max-w-[90vw] rounded-lg bg-white shadow-lg">
        <div className="flex flex-col items-center gap-0">
          {/* Content */}
          <div className="flex flex-col items-center gap-1 p-4">
            {/* Input Frame */}
            <div className="flex h-11 w-80 items-center gap-2.5 rounded-xl bg-grey10 px-4 py-3">
              <input
                type="text"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                className="w-full bg-transparent text-sm font-normal text-content1 outline-none placeholder:text-grey40"
                placeholder="Enter tag name..."
              />
            </div>
          </div>
          <div className="flex w-full flex-col items-end justify-center gap-8 border-t border-grey30 px-4 py-3 pb-4">
            <div className="flex w-60 items-stretch gap-3">
              <Button
                variant="secondaryGreen"
                label="Cancel"
                handleClick={handleCancel}
                className="h-9 flex-1 text-sm font-medium"
              />
              <Button
                variant="primary"
                label="Save"
                handleClick={handleSave}
                className="h-9 flex-1 text-sm font-medium"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategoryModal;
